import React from "react";
import { Box, Card, Button, Typography } from "@mui/material";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./cisoDashboard.module.scss";

const scatterData = [
  { x: 12, y: 30, z: 80 },
  { x: 22, y: 50, z: 90 },
  { x: 30, y: 40, z: 60 },
  { x: 40, y: 65, z: 95 },
  { x: 55, y: 70, z: 75 },
  { x: 60, y: 45, z: 50 },
  { x: 75, y: 85, z: 100 },
  { x: 82, y: 30, z: 55 },
  { x: 90, y: 92, z: 110 },
];

export const AssetRiskHeatmap = () => {
  return (
    <Card
      className={styles.card}
      sx={{ width: "100%" }}
      variant="outlined"
      elevation={0}
    >
      <Box className={styles.sectionTitleRow}>
        <Typography className={styles.sectionHeading} fontWeight={600}>
          Asset Risk Heatmap
        </Typography>
        <Button size="small" variant="outlined" className={styles.tagButton}>
          Last 7 days
        </Button>
      </Box>
      <Box className={styles.heatmap}>
        <ResponsiveContainer width="100%" height="100%">
          <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
            <CartesianGrid stroke="#E5E7EB" />
            <XAxis
              type="number"
              dataKey="x"
              name="Criticality"
              domain={[0, 100]}
            />
            <YAxis
              type="number"
              dataKey="y"
              name="Severity"
              domain={[0, 100]}
            />
            <ZAxis type="number" dataKey="z" range={[50, 400]} />
            <Tooltip cursor={{ strokeDasharray: "3 3" }} />
            <Scatter data={scatterData} fill="#0CA6F2" />
          </ScatterChart>
        </ResponsiveContainer>
      </Box>
    </Card>
  );
};

export default AssetRiskHeatmap;
